import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAANqmZ4fz4fspX1URJRXp5lDMo7rWnQv8",
  authDomain: "jewelry-a0096.firebaseapp.com",
  projectId: "jewelry-a0096",
  storageBucket: "jewelry-a0096.appspot.com",
  messagingSenderId: "927520867849",
  appId: "1:927520867849:web:YOUR_WEB_APP_ID"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);







